export const PRIMARY_NAV_LINKS = [
  { key: "services", href: "/leistungen" },
  { key: "financing", href: "/finanzierung" },
  { key: "properties", href: "/immobilien" },
  { key: "newHome", href: "/umziehen-in-heilbronn" },
  { key: "calculate", href: "/immobilienbewertung" },
] as const;

export const SECONDARY_NAV_LINKS = [
  { key: "home", href: "/" },
  { key: "about", href: "/ueber-mich" },
  { key: "inheritance", href: "/erbschaft" },
  { key: "team", href: "/team" },
  { key: "faq", href: "/faq" },
  { key: "blog", href: "/blog" },
  { key: "contact", href: "/kontakt" },
] as const;

export const FOOTER_NAV_LINKS = [...PRIMARY_NAV_LINKS, ...SECONDARY_NAV_LINKS] as const;
